import { render, staticRenderFns } from "./place.vue?vue&type=template&id=43512b74&scoped=true"
import script from "./place.vue?vue&type=script&lang=js"
export * from "./place.vue?vue&type=script&lang=js"
import style0 from "./place.vue?vue&type=style&index=0&id=43512b74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43512b74",
  null
  
)

export default component.exports